// Success action with no business payload: an export is a local side effect (browser download), not
// a server mutation with a resource to carry back. It still has to exist and be dispatched/returned —
// an applicative function is never allowed to return `Promise<void>`.
export type AuditTrailExportedAction = {
	type: 'AUDIT_TRAIL_EXPORTED';
};

export default (): AuditTrailExportedAction => ({
	type: 'AUDIT_TRAIL_EXPORTED',
});
